import React, { useState, useEffect, useContext } from "react";
import styled from "styled-components";
import { FillerText, ProceedButton, Banner1, SDK, CenterCard } from "./common";
import { TextField } from "@mui/material";
import { v4 as uuidv4 } from "uuid";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import AppContext from "../context/AppContext";
import { MdClose } from "react-icons/md";
import moment from "moment";
import StatementList from "../bankconnect/StatementList";
const Container = styled.div`
  width: 100vw;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  top: 0;
  z-index: 2;
`;

const Overlay = styled.div`
  background-color: black;
  position: absolute;
  opacity: 0.5;
  backdrop-filter: blur(10px);
  width: 100vw;
  height: 100vh;
  z-index: 3;
`;
const ModalBottom = styled.div`
  display: flex;
  flex-direction: column;
  width: 350px;
  @media (max-width: 1024px) {
    width: 100%;
  }
`;

const Banner = styled.div`
  width: fit-content;
  height: fit-content;
  background-image: linear-gradient(#ffffff, #f4f7fa, #dae5ef);
  z-index: 4;
  display: flex;
  flex-direction: column;
  align-items: center;
  border-radius: 8px;
  padding: 50px 150px;
  @media (max-width: 1024px) {
    width: 90%;
    padding: 20px;
    text-align: center;
    img {
      height: 120px;
    }
  }
`;

const BasicBanner = styled.div`
  width: fit-content;
  height: fit-content;
  background-color: "white";
  z-index: 4;
  display: flex;
  flex-direction: column;
  align-items: center;
  border-radius: 8px;
  @media (max-width: 1024px) {
    width: 90%;
    padding: 20px;
    text-align: center;
    img {
      height: 120px;
    }
  }
`;
const AskModal = (props) => {
  const context = useContext(AppContext);
  let newToDate = new Date();
  let newFromDate = new Date();
  const [tdat, setDate] = useState(
    new Date(newToDate.setDate(newToDate.getDate() - 1))
  );
  const [fdat, setFdate] = useState(
    new Date(newFromDate.setMonth(newFromDate.getMonth() - context.timep))
  );
  let linkid = uuidv4();
  const tdate = moment(tdat).format("DD/MM/YYYY");
  const [src, setSrc] = useState("");
  const [show, setShow] = useState(false);
  const fdate = moment(fdat).format("DD/MM/YYYY");
  const [loading, setLoading] = useState(true);
  const today = new Date(new Date().setDate(new Date().getDate() - 1));
  const [err, setErr] = useState(false);
  const linkID = "";
  const [link, setLink] = useState(props.linkId || "");
  const fetchStatementList = async (page = 1) => {
    let fT = context.token;
    const ftData = JSON.parse(fT);
    var myHeaders = new Headers();
    myHeaders.append("token", ftData.Token);
    var requestOptions = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow",
    };
    let response;
    try {
      response = await fetch(
        `https://dashboardapi.finbox.in/v1/usage/bank_connect_entities?page=${page}&max=10&link_id=${linkID}&stage=${context.stage}`,
        requestOptions
      );
      if (response.status == 400) {
        window.location.href = "/bankconnect";
        return;
      }
    } catch (err) {
      context.removeToken();
      return;
    }
    const resp = await response.text();
    const json = JSON.parse(resp);
    if (json.Status) {
      props.setData(json.Data.Items);
      props.setTotalPages(json.Data.MaxPages == 0 ? "1" : json.Data.MaxPages);
    }
    setLoading(false);
    // setLinkID("");
  };
  const getSession = async () => {
    let fT = context.token;
    const ftData = JSON.parse(fT);
    var myHeaders = new Headers();
    myHeaders.append("token", ftData.Token);
    const env = context.env;
    const requestBody = {
      stage: "prod",
      fromDate: fdate,
      toDate: tdate,
      linkID: link || linkid,
    };
    const requestOptions = {
      method: "POST",
      redirect: "follow",
      headers: myHeaders,
      body: JSON.stringify(requestBody),
    };
    let res;
    res = await fetch(
      "https://dashboardapi.finbox.in/v1/proxy/bank_connect_session",
      requestOptions
    );

    const json = await res.json();
    if (res.ok) {
      setSrc(json.redirect_url);
      setShow(true);
      let payload;
      window.addEventListener("message", function (event) {
        console.log("Event -> ", event);
        if (event.data.status == "exit") {
          setShow(false);
          props.setModal(false);
          fetchStatementList();
        }
        if (event.data.status == "success") {
          localStorage.setItem("bankConnectLinkId", event.data.payload.linkId);
          payload = event.data.payload;
          if (payload.entityId != null) {
            window.open("/bankconnect/results/" + payload.entityId, "_self");
          }
          setShow(false);
          props.setModal(false);
          event.stopPropagation();
        }
      });
    } else {
      setShow(false);
      props.setModal(false);
      console.log(json.Error);
    }
  };
  useEffect(() => {
    if (fdat > tdat || tdat > today) {
      setErr(true);
    } else setErr(false);
  }, [fdat, tdat, today]);

  return show ? (
    <SDK>
      <iframe
        src={src}
        width="100%"
        height="100%"
        style={{ borderRadius: "10px", borderColor: "white", border: "none" }}
      ></iframe>
    </SDK>
  ) : (
    <Banner1>
      <div style={{ marginLeft: "270px" }}>
        <button
          style={{
            background: "white",
            borderColor: "white",
            borderWidth: "0px",
            tabSize: "20px",
            cursor: "pointer",
          }}
          onClick={() => {
            props.setModal(false);
            setLink("");
          }}
        >
          <MdClose />
        </button>
      </div>
      <img src="https://finbox-cdn.s3.ap-south-1.amazonaws.com/assets/dashboard/modal.svg" />
      <div
        class="row"
        style={{
          width: "250px",
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-evenly",
          flex: 1,
        }}
      >
        <div style={{ textAlign: "center" }}>Please Enter the time period</div>
        <div class="rows">
          <LocalizationProvider dateAdapter={AdapterDateFns}>
            <DatePicker
              label="From Date"
              value={fdat}
              inputFormat="dd/MM/yyyy"
              max={today}
              onChange={(e) => {
                setFdate(e);
              }}
              renderInput={(params) => <TextField {...params} />}
            />
          </LocalizationProvider>
          <br />
          <br />
          <LocalizationProvider dateAdapter={AdapterDateFns}>
            <DatePicker
              label="To Date"
              value={tdat}
              inputFormat="dd/MM/yyyy"
              onChange={(e) => {
                setDate(e);
              }}
              max={today}
              renderInput={(params) => <TextField {...params} />}
            />
          </LocalizationProvider>
        </div>
        <div style={{ textAlign: "center" }}>
          {err ? <text style={{ color: "red" }}>Invalid Dates</text> : ""}
          <div>
            Upload PDF from {fdate} to {tdate}
          </div>
        </div>
        {(context.companyName === "MAS Financial Pvt Ltd" ||
          context.companyName === "MAS Financial Services Limited") && (
          <input
            placeholder="Enter your linkId (optional)"
            style={{
              padding: "5px",
              width: "100%",
              background: "transparent",
              border: "1px ridge gray",
              borderRadius: "4px",
            }}
            value={link}
            onChange={(e) => {
              setLink(e.target.value);
            }}
          />
        )}

        <div style={{ display: "flex", justifyContent: "center" }}>
          <ProceedButton
            style={{ margin: 0 }}
            onClick={() => {
              getSession();
            }}
            err={err}
            disabled={err}
          >
            Proceed
          </ProceedButton>
        </div>
      </div>
    </Banner1>
  );
};
const Opensdk = (props) => {
  return (
    <SDK>
      <iframe
        src={props.src}
        width="100%"
        height="100%"
        style={{ borderRadius: "10px", borderColor: "white", border: "none" }}
      ></iframe>
    </SDK>
  );
};

function Finboxsdk(props) {
  return (
    <Container style={{ display: props.showmodal ? "flex" : "none" }}>
      <Overlay />
      {props.showsdk ? (
        <Opensdk
          src={props.src}
          setShowsdk={(value) => props.setShowsdk(value)}
          setModal={(value) => props.setModal(value)}
        />
      ) : props.askflag ? (
        <AskModal
          setData={props.setData}
          setTotalPages={props.setTotalPages}
          onPrimaryClick={props.onPrimaryClick}
          setModal={(value) => props.setModal(value)}
          linkId={props.linkId}
        />
      ) : (
        ""
      )}
    </Container>
  );
}

export default Finboxsdk;
